import "./CacheHistoryItem.scss";

import React, { memo, useMemo } from "react";

import { SlateEditor } from "../../../../components/SlateEditor/SlateEditor";
import { NodeTypes } from "../../../../components/SlateEditor/slateTypes";
import type { Message } from "../../../../hooks/reactQueryHooks/useRequests";
import { getMessagesList } from "../../../../utils/getMessagesList";

interface ICacheHistoryItemProps {
  message: Message;
}

const CacheHistoryItem: React.FC<ICacheHistoryItemProps> = memo(
  ({ message }) => {
    const defaultValue = useMemo(() => {
      return getMessagesList(message);
    }, [message]);
    return (
      <div className="cache-history-item">
        <div className="role">{message.role}</div>
        <SlateEditor
          defaultValue={defaultValue}
          isLoading={false}
          accessAllowed
          isReadOnly
          inPlayground
        />
      </div>
    );
  },
);

export { CacheHistoryItem };
